import { React, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

export const defaultCriteria = [
  {
    METRIC: "Country Risk",
    IMPORTANCE: "Low",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "A", TYPE: "Positive", POINTS: 5, NOTES: "HK, SG" },
      { option: "B", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "C", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
      { option: "D", TYPE: "Negative (high)", POINTS: -5, NOTES: "" },
    ],
  },
  {
    METRIC: "Industry Risk",
    IMPORTANCE: "Low",
    NOTES: "In tandem with S&P's industry risk methodology",
    LINK: "https://www.spglobal.com/ratings/en/regulatory/article/-/view/sourceId/8304862",
    CHILDREN: [
      { option: "Low cyclicality", TYPE: "Positive", POINTS: 5, NOTES: "" },
      { option: "Moderate cyclicality", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "High cyclicality", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
    ],
  },
  {
    METRIC: "Years in Operation",
    IMPORTANCE: "Medium",
    NOTES: "The period of time from date of incorporation highlights the company's ability to cope with business cycles",
    LINK: "",
    CHILDREN: [
      { option: "less than 3 years", TYPE: "Negative (high)", POINTS: -10, NOTES: "Usually does not have audited financials readily available" },
      { option: "3 years to 7 years", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
      { option: "more than 7 years", TYPE: "Baseline", POINTS: 0, NOTES: "" },
    ],
  },
  // ... keep rest of metrics unchanged
  {
    METRIC: "Industry Reputation / Project Track Record",
    IMPORTANCE: "Medium",
    NOTES: "Showcases a company's ability to carry out works well",
    LINK: "",
    CHILDREN: [
      { option: "Positive industry reputation for standard of execution (for example ability to work on public works, HH subcon, etc.)", TYPE: "Positive", POINTS: 10, MIN: -3, MAX: 5, NOTES: "On gov's approved list of contractors / has a website that displays completed past projects, able to provide a reference list of reputable clients and projects (10+ contracts over 5 years)" },
      { option: "Neutral", TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, NOTES: "Less than 10 contracts over 5 years" },
      { option: "Not enough available from industry sources and advisors", TYPE: "Negative (low)", POINTS: -5, MIN: -3, MAX: 5, NOTES: "" },
      { option: "Negative industry reputation for standard of execution", TYPE: "Negative (high)", POINTS: -10, MIN: -3, MAX: 5, NOTES: "Known instances of poor work delivered, disputes and contra-charges, negative reputation as evidenced by advisors and industry experts." },
    ],
  },
  {
    METRIC: "Customer / Project Concentration",
    IMPORTANCE: "Medium",
    NOTES: "Provides insight of the company's revenue growth and the diversification of revenue streams",
    LINK: "",
    CHILDREN: [
      { option: "Multiple ongoing projects (3 or more projects)", TYPE: "Positive", POINTS: 10, MIN: -3, MAX: 5, NOTES: "Good diversification, strong pipeline (3+ contracts with different clients with on-time payments)" },
      { option: "Few ongoing projects", TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, NOTES: "Decent pipeline (3 contracts or less)" },
      { option: "Not enough available from industry sources and advisors", TYPE: "Negative (low)", POINTS: -5, MIN: -3, MAX: 5, NOTES: "" },
      { option: "No projects", TYPE: "Negative (high)", POINTS: -10, MIN: -3, MAX: 5, NOTES: "" },
    ],
  },
  {
    METRIC: "Winding-up Petitions",
    IMPORTANCE: "Critical",
    NOTES: "Closing of business, liquidation risk",
    LINK: "",
    CHILDREN: [
      { option: "No winding-up petitions", 
        TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Winding-up petitions that have been withdrawn (Past 3 years)", 
        TYPE: "Negative (low)", POINTS: -20, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Existing unsettled winding-up petition", 
        TYPE: "Negative (high)", POINTS: -50, MIN: -3, MAX: 5, 
        NOTES: "" },
    ],
  },
  {
    METRIC: "Material Litigation",
    IMPORTANCE: "Critical",
    NOTES: " Material refers to litigation that relates to debt or disputes that if not won by the Client will result in high financial risk",
    LINK: "",
    CHILDREN: [
      { option: "No material litigation", 
        TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Material litigation that has been settled (Past 3 years)", 
        TYPE: "Negative (low)", POINTS: -20, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Existing material litigation", 
        TYPE: "Negative (high)", POINTS: -50, MIN: -3, MAX: 5, NOTES: "" },
    ],
  },
  {
    METRIC: "Ownership",
    IMPORTANCE: "Medium",
    NOTES: "Availability to alternative funding sources",
    LINK: "",
    CHILDREN: [
      { option: "Resourced (i.e. part of a large parent or listed organization can access funding if needed) ", 
        TYPE: "Positive", POINTS: 10, MIN: -3, MAX: 5, 
        NOTES: "Applicable to debtor" },
      { option: "Under-resourced (i.e.no option for support or support unlikely)", 
        TYPE: "Negative (low)", POINTS: -5, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Potentially-distressed (i.e. owner is in financial difficulty, likely to borrow from the company)", 
        TYPE: "Negative (high)", POINTS: -10, MIN: -3, MAX: 5, 
        NOTES: "Large amount due from director(s) and related companies on balance sheet" },
    ],
  },
  {
    METRIC: "Management Ability",
    IMPORTANCE: "Low",
    NOTES: "Quality of manpower & expertise",
    LINK: "",
    CHILDREN: [
      { option: "Sole founder/owner with little industry experience", 
        TYPE: "Negative (high)", POINTS: -5, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Executive team with little industry experience", 
        TYPE: "Negative (low)", POINTS: -3, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Sole founder/owner with considerable industry experience", 
        TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Executive team with considerable industry experience", 
        TYPE: "Positive", POINTS: 5, MIN: -3, MAX: 5, 
        NOTES: "Applicable to debtor" },
    ],
  },
  {
    METRIC: "Administrative Capacity",
    IMPORTANCE: "Low",
    NOTES: "Level of organization",
    LINK: "",
    CHILDREN: [
      { option: "High", 
        TYPE: "Positive", POINTS: 5, MIN: -3, MAX: 5, 
        NOTES: "Displaying quick, accurate, and organized communication and reporting, able to provide audited reports and management accounts / applicable to debtor" },
      { option: "Medium (meets expectations)", 
        TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, 
        NOTES: "" },
      { option: "Low (known instances of missing or inaccurate processes/information)", 
        TYPE: "Negative (low)", POINTS: -3, MIN: -3, MAX: 5, 
        NOTES: "Disorganized communication, known instances of errors in information provided, lack of audited financial annual reports." },
    ],
  },
  {
    METRIC: "Repayment Track Record of Riverchain's loans",
    IMPORTANCE: "Medium",
    NOTES: "Refinancing risk",
    LINK: "",
    CHILDREN: [
      { option: "Timely", 
        TYPE: "Positive", POINTS: 10, MIN: -3, MAX: 5, 
        NOTES: "Credible borrower (track record of 6+/6 months of on-time payments)" },
      { option: "N/A (no information on track record)", 
        TYPE: "Baseline", POINTS: 0, MIN: -3, MAX: 5, 
        NOTES: "N/A for new borrower / applicable to debtor" },
      { option: "Slight delay", 
        TYPE: "Negative (low)", POINTS: -5, MIN: -3, MAX: 5, 
        NOTES: "Moderate default risk (an instance of delay in payment past 15 days)  /  < 20% no. of times of late payment" },
      { option: "Significant delay", 
        TYPE: "Negative (high)", POINTS: -10, MIN: -3, MAX: 5, 
        NOTES: "High default risk (more than one instance of delay in payment past 15 days)  / > 20% no of times of late payment" },
      
    ],
  },
];
export const FinancialCriteria = [
  {
    METRIC: "Revenue (Last Year)",
    IMPORTANCE: "Medium",
    NOTES: "hh",
    LINK: "",
    CHILDREN: [
      { option: "> than HK$ 100,000,000", TYPE: "Positive", POINTS: 10, NOTES: "" },
      { option: "between HK$ 20,000,000 and HK$ 100,000,000", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "between HK$ 5,000,000 and HK$ 20,000,000", TYPE: "Negative (low)", POINTS: -5, NOTES: "" },
      { option: "< than HK$ 5,000,000", TYPE: "Negative (high)", POINTS: -10, NOTES: "" },
    ],
  },
  {
    METRIC: "Revenue Growth (2-Year CAGR)",
    IMPORTANCE: "Low",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "Revenue growth is > than 20%", TYPE: "Positive", POINTS: 5, NOTES: "" },
      { option: "Revenue growth between 0% and 20%", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Revenue growth is < than 0%", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
    ],
  },
  {
    METRIC: "Gross Profit Margin (Average 3 Year)",
    IMPORTANCE: "Low",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "Avg. gross margin is > than 20%", TYPE: "Positive", POINTS: 5, NOTES: "" },
      { option: "Avg. gross margin is between 0% and 20%", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Avg. gross margin is < than 0%", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
    ],
  },
  {
    METRIC: "Liquidity (Current Ratio) (Last Year)",
    IMPORTANCE: "Low",
    NOTES: "Current assets / Current liabilities (exclude amounts due from related companies and directors in the assets value)",
    LINK: "",
    CHILDREN: [
      { option: "Current ratio is > 1.5 ", TYPE: "Positive", POINTS: 5, NOTES: "" },
      { option: "Current ratio is between 1.0 and 1.5", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Current ratio is < 1.0 ", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
    ],
  },
   {
    METRIC: "Liquidity (Quick Ratio) (Last Year)",
    IMPORTANCE: "Medium",
    NOTES: "Cash, cash equivalents, accounts receivables, and short-term investments / Current liabilities (exclude amounts due to related parties)",
    LINK: "",
    CHILDREN: [
      { option: "Quick ratio is > 1.5", TYPE: "Positive", POINTS: 10, NOTES: "" },
      { option: "Quick ratio is between 1.0 and 1.5", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Quick ratio is < 1.0", TYPE: "Negative (low)", POINTS: -5, NOTES: "" },
    ],
  },
  {
    METRIC: "Liquidity - Cash Conversion Cycle (Last Year)",
    IMPORTANCE: "Medium",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "0 - 45 days", TYPE: "Positive", POINTS: 10, NOTES: "" },
      { option: "45 - 90 days", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "> 90 days", TYPE: "Negative (low)", POINTS: -5, NOTES: "" },
    ],
  },
  {
    METRIC: "Cashflow from Operating Activities (Last Year)",
    IMPORTANCE: "Low",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "> 0", TYPE: "Positive", POINTS: 5, NOTES: "" },
      { option: "< 0", TYPE: "Negative (low)", POINTS: -3, NOTES: "" },
    ],
  },
  {
    METRIC: "Quality of Assets",
    IMPORTANCE: "Medium",
    NOTES: "Due from director & related entities / total assets",
    LINK: "",
    CHILDREN: [
      { option: "< 10% of related parties assets", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "10% - 20% of related parties assets", TYPE: "Negative (low)", POINTS: -5, NOTES: "" },
      { option: "> 20% of related parties assets", TYPE: "Negative (high)", POINTS: -10, NOTES: "" },
    ],
  },
  {
    METRIC: "Solvency (Debt to Assets Ratio) (Last Year)",
    IMPORTANCE: "Medium",
    NOTES: "All bank debt and lease liabilities / Total Assets (exclude amounts from Directors / Related Companies / Subsidiaries)",
    LINK: "",
    CHILDREN: [
      { option: "Debt to Assets ratio is < 0.6", TYPE: "Positive", POINTS: 10, NOTES: "" },
      { option: "Debt to Assets ratio is between 0.6 and 1.0", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Debt to Assets ratio is > 1.0", TYPE: "Negative (low)", POINTS: -5, NOTES: "" },
    ],
  },
  {
    METRIC: "Solvency (Net Leverage Ratio) (Last Year)",
    IMPORTANCE: "Medium",
    NOTES: "All bank debt and lease liabilities / EBITDA",
    LINK: "",
    CHILDREN: [
      { option: "Net debt to EBITDA ratio is < 5.0", TYPE: "Positive", POINTS: 10, NOTES: "" },
      { option: "Net debt to EBITDA ratio is between 5.0 and 8.0", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Net debt to EBITDA ratio is < 0 due to negative EBTITDA or debt to EBITDA ratio > 8.0 ", TYPE: "Negative (high)", POINTS: -10, NOTES: "" },
    ],
  },
  {
    METRIC: "Interest Coverage (Last Year)",
    IMPORTANCE: "Medium",
    NOTES: "EBITDA / Interest Expense",
    LINK: "",
    CHILDREN: [
      { option: "Interest coverage ratio is > 2.0", TYPE: "Positive", POINTS: 10, NOTES: "" },
      { option: "Interest coverage ratio is between 1.5 and 2.0", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Interest coverage ratio is between 1.0 and 1.4", TYPE: "Negative (low)", POINTS: -5, NOTES: "" },
      { option: "Interest coverage ratio is < 1.0", TYPE: "Negative (high)", POINTS: -10, NOTES: "" },
    ],
  },
  {
    METRIC: "Lack of Opinion / Qualified Opinion from Auditor",
    IMPORTANCE: "Critical",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "Unqualified / N/A", TYPE: "Baseline", POINTS: 0, NOTES: "" },
      { option: "Qualified with non-material qualifications", TYPE: "Negative (low)", POINTS: -20, NOTES: "" },
      { option: "Qualified with material qualifications / Unable to provide audited accounts for the past 2 years", TYPE: "Negative (high)", POINTS: -50, NOTES: "Auditor does not have an opinion" },
    ],
  },
  {
    METRIC: "Known Defaults on Borrowings/Loans (Last 2 Years)",
    IMPORTANCE: "Critical",
    NOTES: "",
    LINK: "",
    CHILDREN: [
      { option: "Yes", TYPE: "Negative (high)", POINTS: -50, NOTES: "" },
      { option: "No", TYPE: "Baseline", POINTS: 0, NOTES: "" },
    ],
  },
];
// ----------------- Default Matrix -----------------
export const defaultMatrix = [
  { importance: "Low", positive: 5, baseline: 0, negativeLow: -3, negativeHigh: -5 },
  { importance: "Medium", positive: 10, baseline: 0, negativeLow: -5, negativeHigh: -10 },
  { importance: "Critical", positive: 10, baseline: 0, negativeLow: -20, negativeHigh: -50 },
];